module.exports = __webpack_public_path__ + "img/gymkee2.b4ea4cad.png";